// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"city-4"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M16 21V10L12 8L8 10V21H16Z"},"nodeName":"path","children":[]},{"attributes":{"id":"fill2"},"nodeName":"g","children":[{"attributes":{"fill":"transparent","d":"M3 21H8V5L5.5 3L3 5V21Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"transparent","d":"M21 21V5L18.5 3L16 5V21H21Z"},"nodeName":"path","children":[]}]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M11 13H13M12 21V17","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M8 21H3V5L5.5 3L8 5V21ZM8 21H16M16 21H21V5L18.5 3L16 5V21ZM8.5 9.75L12 8L15.5 9.75","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-city-4')
export default class City4Icon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'city-4',
    }
  }
}
